// extracted by mini-css-extract-plugin
export var dividerLine = "_a2-3";
export var itemImage = "_a2-9";
export var lightDivider = "_a2-4";
export var modalContent = "_a2-5";
export var modalContentCompact = "_a2-6";
export var productCard = "_a2-a";
export var productImage = "_a2-b";
export var productImageCompact = "_a2-7";
export var productImagePlaceholder = "_a2-c";
export var productImagePlaceholderCompact = "_a2-8";
export var progressBarBackground = "_a2-1";
export var progressBarContainer = "_a2-0";
export var progressBarFill = "_a2-2";